import { useEffect, useState } from "react";
import { esquecerSessaoLocal, supabaseResponde } from "../lib/supabase";

/**
 * A sessão não carregou: diz se o Supabase do computador está fora do ar ou se é a sessão
 * guardada no navegador que travou, e o que fazer. Confere de novo a cada 5 s.
 */
export function SemConexao() {
  const [responde, setResponde] = useState<"ok" | "chave" | "fora" | null>(null);

  useEffect(() => {
    let ativo = true;
    const conferir = () => void supabaseResponde().then((r) => { if (ativo) setResponde(r); });
    conferir();
    const t = setInterval(conferir, 5000);
    return () => { ativo = false; clearInterval(t); };
  }, []);

  return (
    <div className="mx-auto flex max-w-xl flex-col gap-4 p-6">
      <h1 className="font-sinal text-3xl font-bold">
        {responde === "fora" ? "O Supabase do computador não está respondendo"
          : responde === "chave" ? "A chave do Supabase não confere" : "A sessão não carregou"}
      </h1>
      {responde === "fora" ? (
        <ol className="list-decimal space-y-1 pl-5">
          <li>Confira se o Docker Desktop está aberto e mostra "Engine running".</li>
          <li>Logo depois de ligar, o Supabase leva 1 ou 2 minutos para subir: espere esta tela sumir sozinha.</li>
          <li>Se não sumir, feche as janelas do WMS e rode o <code>iniciar-wms.bat</code> de novo.</li>
          <li>Se a janela mostrar erro do Supabase, mande um print dela.</li>
        </ol>
      ) : responde === "chave" ? (
        <p>
          O Supabase está no ar, mas recusou a chave do arquivo <code>web/.env.local</code>. Rode <code>supabase status</code> na pasta
          do projeto e copie a chave pública (anon ou publishable) para <code>VITE_SUPABASE_ANON_KEY</code>.
        </p>
      ) : (
        <p>{responde === null ? "Conferindo o Supabase..." : "O Supabase responde, mas a sessão guardada neste navegador travou. Entre de novo."}</p>
      )}
      <p className="text-sm text-aco-escuro">Esta tela confere de novo a cada 5 segundos e some sozinha quando a conexão voltar.</p>
      <div className="flex flex-wrap gap-2">
        <button type="button" className="min-h-12 rounded-md bg-tinta px-5 font-semibold text-white" onClick={() => window.location.reload()}>
          Tentar de novo
        </button>
        <button type="button" className="min-h-12 rounded-md border-2 border-tinta px-5 font-semibold" onClick={esquecerSessaoLocal}>
          Sair e entrar de novo
        </button>
      </div>
    </div>
  );
}
